export default __webpack_public_path__ + "static/media/Technology.2b45a460.png";